import axios from "axios";
import {setStorage,getAuthHeader} from '../config/Utils'



export const getCountries=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/countries`
    return axios.get(url).then((res)=>{
        return res.data
    })
}
export const getCities=async(cid)=>{
    const url=`${process.env.REACT_APP_API_URL}/cities?cid=${cid}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}
export const getEmirates=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/emirates?cid=${id}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}
export const getCourses=async(cid,clid,ceid)=>{
    const url=`${process.env.REACT_APP_API_URL}/courses?cid=${cid}&&class=${clid}&&center=${ceid}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}
export const getCurriculums=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/curriculums?cid=${id}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}
export const getCountryCode=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/country-code?cid=${id}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}
export const  getStudyCenter=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/study-centers?cid=${id}`
    return axios.get(url).then((res)=>{
        return res.data
    })  
}

export const getSchools=async(cid,eid,ctid)=>{
    const url=`${process.env.REACT_APP_API_URL}/schools?cid=${cid}`
    return axios.get(url).then((res)=>{
        return res.data
    })
    
}
export const getAdmissionMode=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/admission-mode`
    return axios.get(url).then((res)=>{
        return res.data
    })
}

export const getSourceMode=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/sourses`
    return axios.get(url).then((res)=>{
        return res.data
    })
}

export const getClasses=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/classes`
    return axios.get(url).then((res)=>{
        return res.data
    })
}

export const registerUser=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/register-user`
    return axios.post(url,body).then((res)=>{
        if (res.data.status) {
            setStorage("token", res.data.data.token);
            setStorage("userDetail", res.data.data);
        }
        return res.data
    })
}

export const changePassword=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/change-password`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })
}


export const getStudyMaterialCountryCode=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/study-material-country-code?cid=${id}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getCountriesNewList=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/countries-list`
    return axios.get(url).then((res)=>{
      
        return res.data
    })
}